import { Component, EventEmitter, Inject, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DwComponent, DwComponentSectionConfigPreference, DwComponentType, DwContainerOptions, DwContext, DwExpressionService, DwFormContextMode, DwItemAttribute, DwMessage, DwMessageSeverity, DwMetaDataFormApi, DwMetaDataFormConfig, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwSectionBasePreference, DwSecurityUserService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwUiConfigRegistryService, deepCopy } from '@devwareapps/devware-cap';
import { combineLatest, Observable, of, Subscription } from 'rxjs';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
import { AppMetaData, AppMetaDataItemNames, CheckrideActiveApplicantCheckridesQueryEntity, CheckRideApplicantTypeAllItems, CheckRideExaminerTypeAllItems, CheckRideRequestEntity, CheckRideRequestPaymentPartyEntity, CheckRideTestTypeAllItems, CheckRideWorkflowAllItems, PilotExaminerLocationEntity, PilotExaminerSearchQueryEntity } from '../../../../meta-data/app-meta-data.service';
import { ExaminerLocationSearchRequest } from '../../../examiner/models/examiner-location-search-request.model';
import { ExaminerLocationDetail, ExaminerLocationSelection } from '../../../examiner/models/exminer-location-selection.model';
import { debounceTime, map, mergeMap, tap } from 'rxjs/operators';
import { PilotExaminerSearchQueryEntityExt } from '../../../../meta-data/extensions/pilot-examiner-search-query-ext.model';
import { ApplicantRepositoryService } from '../../../applicant/services/applicant-repository.service';
import { ScheduleHoldUtilService } from '../../services/schedule-hold-util.service';
import { ScheduleHoldResultAction } from '../../../examiner/models/schedule-hold-result.model';
import { ExaminerBookingSearchResultsConfigComponent } from '../examiner-booking-search-results-config/examiner-booking-search-results-config.component';
import { ExaminerBookingSearchConfig } from '../../models/examiner-booking-search-config.model';
import { ExaminerBookingVariableContext } from '../../models/examiner-booking-variable-context.model';
import { ScheduleSelectorService } from '../../services/schedule-selector.service';
import { AdminManagerService } from '../../../shared/services/admin-manager.service';
import { PilexosUserTypeIds } from '../../../shared/models/pilexos-user-type.enum';



@DwComponent({
  key: 'exminer-booking-search-results',
  name: ' Examiner Booking Search Results',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.CheckRideRequest,
  configComponent: ExaminerBookingSearchResultsConfigComponent,
  isGlobal: false
})
@Component({
  selector: 'app-examiner-booking-search-results',
  templateUrl: './examiner-booking-search-results.component.html',
  styleUrls: ['./examiner-booking-search-results.component.scss'],
  // providers: [ScheduleSelectorService]
})
export class ExaminerBookingSearchResultsComponent extends DwSectionBaseComponent<DwComponentSectionConfigPreference<ExaminerBookingSearchConfig>> {

  loading: boolean = false;
  loadingMessage: string;

  message: DwMessage = null;

  showSearch: boolean = true;
  searchResults: PilotExaminerSearchQueryEntityExt[];

  // examinerLocationSelection: ExaminerLocationSelection = {
  //   confirmed: false,
  //   totalSelected: 0,
  //   totalAllowed: 5,
  //   currentSearchResult: null  
  // };

  // examinerLocationDetails: ExaminerLocationDetail[] = [];;

  initComplete = false;
  checkRideRequest: CheckRideRequestEntity;
  lastCheckRideRequest: CheckRideRequestEntity;
  backupCheckride: CheckRideRequestEntity;
  allowCancel: boolean;
  variableInitComplete: boolean = false;
  lastVariables: ExaminerBookingVariableContext;
  variableWatchSubscription: Subscription;
  resetMessage: string;
  checkRideRequestPaymentPartyList: CheckRideRequestPaymentPartyEntity[];
  activeCheckrides: CheckrideActiveApplicantCheckridesQueryEntity[];
  formApi: DwMetaDataFormApi;

  allowedSelections: number = 1;
  selectedText: string;
  showMultipleCreation: boolean;

  showManualBookingButton: boolean = false;
  searchRequest: ExaminerLocationSearchRequest;
  lastSearchRequest: ExaminerLocationSearchRequest;

  //testType: CheckRideTestTypeAllItems;

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private examinerRepositoryService: ExaminerRepositoryService,
    private applicantRepositoryService: ApplicantRepositoryService,
    private scheduleHoldUtilService: ScheduleHoldUtilService,
    private scheduleSelectorService: ScheduleSelectorService,
    private adminManagerSerice: AdminManagerService,
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);

    this.formApi = dwMetaDataFormStateService.state.formApi;

    // const data = dwMetaDataFormStateService.state.formApi.getFormData<CheckRideRequestEntity>();

    // data.CheckRideApplicantTypeId = CheckRideApplicantTypeAllItems.FlightSchoolStudent;

    // dwMetaDataFormStateService.state.formApi.patchFormData(data);
  }


  ngOnDestroy(): void {
    super.ngOnDestroy();

    if (this.variableWatchSubscription) {
      this.variableWatchSubscription.unsubscribe();
      this.variableWatchSubscription = null;
    }

  }

  setupComponentComplete() {
    this.setupDataWatch();

    if (this.sectionConfig.config?.showSchoolManualBookingButton) {
      this.showManualBookingButton = true;
    }

    this.visibleChange
      .pipe(debounceTime(10))
      .subscribe(visible => {
        if (visible) {
          this.dataUpdated();
        }

      });

    this.examinerRepositoryService.getCheckRideRequestPaymentParty().subscribe(results => {
      this.checkRideRequestPaymentPartyList = results;
    });

    this.setupSelectorEvents();
  }

  switchToManualBooking() {
    let variableContext = this.formApi.getVariableContextValue<ExaminerBookingVariableContext>();

    const checkride = this.formApi.getFormData<CheckRideRequestEntity>();

    const checkrideUpdate: Partial<CheckRideRequestEntity> = {
      CheckRideWorkflowId: CheckRideWorkflowAllItems.SchoolWorkflowManualNoPilexosExaminer,
      ScheduledAirportId: checkride.PreferredAirportId,
      ScheduledDateTime: null, //checkride.PreferredDateTime,
      CheckRideExaminerTypeId: CheckRideExaminerTypeAllItems.FlightSchoolExaminer,
      ScheduledPilotExaminerId: null,
      ExaminerBookingCost: null,
      ScheduledCheckRideCost: null,
      AdditionalTravelCost: null
    };

    if (variableContext.Applicants && variableContext.BookMultiple) {
      const applicantIds = variableContext.Applicants.split(',').map(id => parseInt(id, 10));

      if (applicantIds.length == 1) {
        checkrideUpdate.FlightSchoolApplicantId = applicantIds[0];
      }
    }

    this.formApi.patchFormData(checkrideUpdate);
  }

  setupSelectorEvents() {
    this.subscriptions.push(
      this.scheduleSelectorService.countChange.subscribe(() => {
        setTimeout(() => {
          this.selectedText = `${this.scheduleSelectorService.examinerLocationSelection.totalSelected} of ${this.scheduleSelectorService.examinerLocationSelection.totalAllowed} Selected`;
        });
      }));

    this.subscriptions.push(
      this.scheduleSelectorService.confirm.subscribe(() => {
        if (this.scheduleSelectorService.examinerLocationSelection.totalAllowed > 1) {
          //this.showMultipleCreation = true;

          this.patchContext({
            Show_Proposed_Search: false,
            Show_Search: false,
            Checkride_Date_No_Longer_Valid: false,
          });
          // this.setVariable(this.SHOW_PROPOSED_SEARCH, false);
          // this.setVariable(this.SHOW_SEARCH, false);
          // this.setVariable(this.Checkride_Date_No_Longer_Valid, false);

          return;
        }

        this.examinerLocationSelected();
      }));
  }


  setupDataWatch() {
    const obs: Observable<any>[] = [];

    obs.push(this.formApi.getFormDataChanges(0));
    obs.push(this.formApi.getVariableContext());

    combineLatest(obs)
      .pipe(debounceTime(50))
      .subscribe(([dataChange, variableContext]) => {
        if (this.formApi.isDataLoadComplete) {
          this.dataUpdated();
        }
      });

    // this.subscriptions.push(
    //   this.dwMetaDataFormStateService.state.formApi.getFormDataChanges(50)
    //     .subscribe(dataChange => {
    //       if (this.dwMetaDataFormStateService.state.formApi.isDataLoadComplete) {
    //         this.dataUpdated();
    //       }
    //     }));

    // this.setupVariableChangeWatch();

    if (this.dwMetaDataFormStateService.state.formApi.isDataLoadComplete) {
      this.dataUpdated();
    }
  }

  variables: ExaminerBookingVariableContext;

  private dataUpdated() {
    this.checkRideRequest = this.dwMetaDataFormStateService.state.formApi.getFormData<CheckRideRequestEntity>();

    if (!this.variableInitComplete) {
      this.initVariables();
      this.variableInitComplete = true;
    }

    if (!this.visible) {
      return;
    }

    if (!this.hasMinimumRequiredFields(this.checkRideRequest)) {
      return;
    }

    const variables = this.getVariables();
    this.variables = variables;

    if (this.checkforSearchChanges(this.checkRideRequest, variables)) {
      return;
    };

    let forceHideCancel = false;

    if (variables.Checkride_Date_No_Longer_Valid) {
      forceHideCancel = true;
    }

    if (this.checkRideRequest.ScheduledPilotExaminerId && !forceHideCancel) {
      this.allowCancel = true;
    }

    if (variables.Show_Search) {
      // console.log("Kicking off search for checkride", variables);

      //      this.search();

      return;
    }

    if (variables.Show_Proposed_Search) {
      //  console.log("Kicking off proposed search for checkride", variables);
      this.search(true);

      if (!forceHideCancel) {
        this.allowCancel = true;
      }
    }
  }


  checkforSearchChanges(checkRideRequest: CheckRideRequestEntity, variables: ExaminerBookingVariableContext): boolean {

    if (variables.Show_Search == false) {
      //console.log("Show Search for to false");
    }

    let resetSearch = false;

    if (!checkRideRequest || !variables || !this.lastCheckRideRequest || !this.lastVariables) {

      this.lastCheckRideRequest = deepCopy(checkRideRequest);
      this.lastVariables = { ...variables };

      return false;
    }

    if (!this.lastSearchRequest) {
      this.lastCheckRideRequest = deepCopy(checkRideRequest);;
      this.lastVariables = { ...variables };
      return;
    }

    if (this.sectionConfig.config?.allowMultipleBookings && variables.Applicants != this.lastVariables.Applicants) {
      // Applicants changed, but 
      if (!this.searching && this.searchResults?.length > 0 && this.scheduleSelectorService.examinerLocationSelection && !variables.ApplicantsAreInvalid) {
        // Resetup the results which will reset the selections (no need to search again)
        const previousSearchResults = deepCopy(this.searchResults);

        this.searchResults = null;
        this.loading = true;
        this.loadingMessage = "Updating search selections";

        setTimeout(() => {
          this.loading = false;
          this.setupSearchResults(previousSearchResults);
        }, 150);
      }
    }



    // Cancel the hold if we are searching again
    if (this.lastVariables.Show_Search != variables.Show_Search && variables.Show_Search) {
      this.cancelScheduleHold(this.checkRideRequest);
    }

    // Ignore if we haven't searched yet
    if (!this.searchResults || this.searchResults.length == 0) {

      if (this.lastVariables.ApplicantsAreInvalid == variables.ApplicantsAreInvalid) {
        this.lastVariables = variables;
        return false;
      }
    }

    const propertyChanges: string[] = [];


    const newSearchRequest = this.buildSearchRequest();

    if (this.hasSearchRequestChanged(newSearchRequest, this.lastSearchRequest, propertyChanges)) {
      resetSearch = true;
    }

    if (this.lastVariables.ApplicantsAreInvalid != variables.ApplicantsAreInvalid) {
      resetSearch = true;
    }

    if (resetSearch) {
      this.searchResults = null;

      // console.log('Search criteria changed, resetting search results', propertyChanges);

      this.message = {
        messageBody: 'Search critieria has changed.  Please search again',
        severity: DwMessageSeverity.warning
      };
    }

    this.lastCheckRideRequest = deepCopy(checkRideRequest);;
    this.lastVariables = { ...variables };

    return resetSearch;
  }

  hasSearchRequestChanged(newSearchRequest: ExaminerLocationSearchRequest, lastSearchRequest: ExaminerLocationSearchRequest, propertyChanges: string[]) {

    const fields: string[] = [];

    for (let field in newSearchRequest) {
      fields.push(field);
    }

    return this.hasPropertyChanges(propertyChanges, newSearchRequest, lastSearchRequest, ...fields);
  }


  hasPropertyChanges(changes: string[], obj1: any, obj2: any, ...properties: (string | DwItemAttribute)[]): boolean {
    for (let property of properties) {

      const propertyName = typeof property === 'string' ? property : property.fieldName;

      if (obj1[propertyName] != obj2[propertyName]) {
        changes.push(`${propertyName} changed from ${obj1[propertyName]} to ${obj2[propertyName]}`);
      }
    }

    return changes.length > 0;
  }

  hasMinimumRequiredFields(checkRideRequest: CheckRideRequestEntity): boolean {
    if (checkRideRequest?.CheckRideGroupId && checkRideRequest?.CheckRideTypeId && checkRideRequest.CheckRideTestTypeId && checkRideRequest.PreferredAirportId) {
      return true;
    }

    if (this.message) {
      this.message = {
        messageBody: 'Please enter the required fields to search for a checkride',
        severity: DwMessageSeverity.warning
      };
    }

    return false;
  }

  initVariables() {
    let showSearch = false;

    if (!this.checkRideRequest.ScheduledPilotExaminerId && this.checkRideRequest.CheckRideWorkflowId != CheckRideWorkflowAllItems.SchoolWorkflowManualNoPilexosExaminer) {
      showSearch = true;
    }

    if (this.formApi.formMode == 'edit') {
      //TODO: Remove to show search first always
      showSearch = false;
    }

    //console.log("Initial Show Search", showSearch);

    this.patchContext({
      Show_Proposed_Search: false,
      Show_Search: showSearch,
    });



    // this.setVariable(this.SHOW_SEARCH, showSearch);

    // this.setVariable(this.SHOW_PROPOSED_SEARCH, false);
  }

  cancelSearch() {
    let holdOb = of(true);

    if (this.scheduleHoldUtilService.requiresScheduleHold(this.checkRideRequest, true)) {
      holdOb = this.startScheduleHold(this.checkRideRequest)
        .pipe(debounceTime(10))
    }

    holdOb
      .subscribe((success) => {
        if (!success) {
          return;
        }

        const variables = this.getVariables();

        if (variables.Show_Search || variables.Show_Proposed_Search) {
          this.formApi.patchVariableContext<ExaminerBookingVariableContext>({
            Show_Search : false,
            Show_Proposed_Search : false,
          })
        }
        // if (variables.Show_Search) {
        //   this.setVariable(this.SHOW_SEARCH, false);
        // }

        // if (variables.Show_Proposed_Search) {
        //   this.setVariable(this.SHOW_PROPOSED_SEARCH, false);
        // }
      });
  }

  examinerLocationSelected() {
    // populate the form
    const entity = AppMetaData.CheckRideRequest.CreateEntity();

    const selection = this.scheduleSelectorService.getSelections()[0];

    // const selection = this.examinerLocationDetails.find(detail => detail.isSelected);
    // TODO: get search result from selection
    const result = selection.searchResult; // : Searchresultentity = selection.searchResult;
    const scheduleDateTime = selection.scheduleDateTime;;

    // if (this.scheduleSelectorService.examinerLocationSelection.confirmed) {
    const variables = this.getVariables();

    let timeMinutes = this.examinerRepositoryService.getCheckrideTimeMinutes(selection.searchResult, this.checkRideRequest.CheckRideTestTypeId);

    if (variables.Show_Proposed_Search) {
      entity.ProposedDateTime = scheduleDateTime;
      entity.ProposedTimeMinutes = timeMinutes;
      entity.ProposedAirportId = result.LocationDistancesAirportId;

      // Set these too so we can use the standard acceptance workflow
      entity.ScheduledDateTime = scheduleDateTime;
      entity.ScheduledTimeMinutes = timeMinutes;
      entity.ScheduledAirportId = result.LocationDistancesAirportId;
      entity.ScheduledPreTimeMinutes = result.ScenarioPreTimeMinutes;
      entity.ScheduledPostTimeMinutes = result.ScenarioPostTimeMinutes;
      entity.ScheduledCheckRideScenarioId = result.ScenarioCheckRideScenarioId;
      entity.ScheduledPilotExaminerLocationId = result.LocationDistancesPilotExaminerLocationId;
      entity.ExaminerToApplicantNotes = result.CheckRideScenarioRequiredDocumentNotes;

      // Set the proposal pending so we can finish up
      this.setVariable(this.PROPOSAL_PENDING, true);
    }

    if (variables.Show_Search) {
      entity.ScheduledPilotExaminerId = result.PilotExaminerId;
      entity.FlightSchoolExaminerId = null;
      entity.CheckRideExaminerTypeId = CheckRideExaminerTypeAllItems.Examiner;

      // Need to convert to
      entity.ScheduledDateTime = scheduleDateTime;
      entity.ScheduledTimeMinutes = timeMinutes;
      entity.ScheduledAirportId = result.LocationDistancesAirportId;
      entity.ScheduledPreTimeMinutes = result.ScenarioPreTimeMinutes;
      entity.ScheduledPostTimeMinutes = result.ScenarioPostTimeMinutes;
      entity.ScheduledCheckRideScenarioId = result.ScenarioCheckRideScenarioId;
      entity.ScheduledPilotExaminerLocationId = result.LocationDistancesPilotExaminerLocationId;
    }

    entity.ScheduledCheckRideCost = this.examinerRepositoryService.getFullBookingCost(result, this.checkRideRequest.CheckRideTestTypeId, this.variables); //result.CheckRideScenarioCheckRideCost || 0 + result.PilotExaminerLocationAdditionalLocationCost || 0;;
    entity.AdditionalTravelCost = result.PilotExaminerLocationTravelCost;
    entity.ExaminerBookingCost = result.CheckRideScenarioBookingCost;
    entity.PilexosBookingCost = this.examinerRepositoryService.getPilexosBookingCost(this.checkRideRequest.CheckRideTestTypeId, this.checkRideRequest.PilexosBookingCostPaymentPartyId, this.checkRideRequestPaymentPartyList);
    entity.ExaminerToApplicantNotes = result.CheckRideScenarioRequiredDocumentNotes;

    entity.FlightSchoolExaminerId = result.FlightSchoolExaminerId;


    if (result.IsSchoolBlockExaminer) {
      // if it's a school examiner block, then we need to set the workflows and examiner type accordingly
      entity.CheckRideWorkflowId = CheckRideWorkflowAllItems.SchoolWorkflowManualNoPilexosExaminer;
      entity.CheckRideExaminerTypeId = CheckRideExaminerTypeAllItems.FlightSchoolExaminer;
    }

    // Get the full updated checkride since we haven't updated the form yet.  This caused it to by pass the hold requirement since the ScheduledPilotExaminerId wasn't set yet.
    const fullCheckride = { ...this.checkRideRequest, ...entity };

    let scheduleHoldOb = this.startScheduleHold(fullCheckride);

    if (!this.scheduleHoldUtilService.requiresScheduleHold(fullCheckride, true)) {
      scheduleHoldOb = of(true);
    } else {
      if (this.sectionConfig?.config?.allowMultipleBookings && this.scheduleSelectorService.getSelections().length > 1) {
        scheduleHoldOb = of(true);
      }
    }

    scheduleHoldOb
      .pipe(debounceTime(10))
      .subscribe((success) => {
        if (!success) {
          this.message = {
            messageBody: 'Unable to place a hold on the selected slot.  Please try again or select a different date/time.',
            severity: DwMessageSeverity.warning
          }
          return;
          //this.search(false, true);
          return;
        }

        this.completeExaminerLocationSelection(entity, result);
      });
  }

  completeExaminerLocationSelection(checkrideRequest: CheckRideRequestEntity, result: PilotExaminerSearchQueryEntityExt) {

    this.dwMetaDataFormStateService.state.formApi.patchFormData(checkrideRequest);

    this.searchResults = [result];

    const variableContextUpdate: Partial<ExaminerBookingVariableContext> = {
      Show_Proposed_Search: false,
      Show_Search: false,
      Checkride_Date_No_Longer_Valid: false,
    };

    this.formApi.patchVariableContext(variableContextUpdate);

    // this.setVariable(this.SHOW_PROPOSED_SEARCH, false);
    // this.setVariable(this.SHOW_SEARCH, false);
    // this.setVariable(this.Checkride_Date_No_Longer_Valid, false);
  }

  searching = false;

  private buildSearchRequest(): ExaminerLocationSearchRequest {
    const checkRideRequest = this.dwMetaDataFormStateService.state.formApi.getFormData<CheckRideRequestEntity>();

    const variables = this.getVariables();

    this.message = null;
    const searchRequest: ExaminerLocationSearchRequest = {
      aviationAuthorityId: checkRideRequest.AviationAuthorityId,
      checkRideGroupId: checkRideRequest.CheckRideGroupId,
      checkRideTypeId: checkRideRequest.CheckRideTypeId,
      checkRideTestTypeId: checkRideRequest.CheckRideTestTypeId,
      preferredAirportId: parseInt(checkRideRequest.PreferredAirportId?.toString()),
      preferredDateTime: this.convertDate(checkRideRequest.PreferredDateTime),
      preferredExaminerId: variables.Preferred_Pilot_Examiner_Id,
      preferredFlightSchoolExaminerId: variables.Preferred_School_Examiner,
      searchOtherAirports: variables.Search_Other_Airports,
      searchWithinMiles: variables.Within_Miles || 50,
      flightSchoolId: checkRideRequest.FlightSchoolId,
      flightSchoolTypeId: checkRideRequest.FlightSchoolTypeId,
    };

    return searchRequest;
  }



  search(noMesage: boolean = false, keepMessage: boolean = false) {
    if (this.searching) {
      return;
    }

    this.searching = true;


    this.message = null;
    const searchRequest = this.buildSearchRequest();

    this.lastSearchRequest = { ...searchRequest }; // copy search request

    const variables = this.getVariables();

    if (!searchRequest.checkRideTypeId || !searchRequest.preferredAirportId || !searchRequest.checkRideTestTypeId || variables.ApplicantsAreInvalid) {
      this.loading = false;

      if (!noMesage) {
        this.message = {
          messageBody: 'Please fill out the required fields to search',
          severity: DwMessageSeverity.error
        };

        if (variables.ApplicantsAreInvalid) {
          this.message = {
            messageBody: 'Please update the applicants to be for the same Category/Class',
            severity: DwMessageSeverity.error
          };
        }
      }

      this.searching = false;

      return;
    }

    this.validateActiveCheckrides(searchRequest)
      .subscribe((valid) => {
        if (!valid) {
          this.loading = false;

          if (!noMesage) {
            this.message = {
              messageBody: 'You already have an active checkride scheduled for this Category/Class.  Please cancel the active checkride to add a new one',
              severity: DwMessageSeverity.error
            };
          }
          this.searching = false;

          return;
        }


        this.loadResults(searchRequest, true, keepMessage)
          .subscribe(searchResults => {

            this.searching = false;

            searchResults = searchResults || [];

            if (searchResults.length == 0) {
              this.message = {
                messageBody: 'No check rides available for your current criteria.  Adjust your criteria and try again',
                severity: DwMessageSeverity.warning
              };

              //this.examinerLocationSelection = null;

              this.loading = false;

              return;
            }

            setTimeout(() => {
              this.loading = false;
            }, 250)
          });

      });
  }

  activeCheckridesValidated = false;
  lastActiveCheckrideTypeId: number;
  activeCheckrideValidationResult: boolean = null;

  validateActiveCheckrides(searchRequest: ExaminerLocationSearchRequest): Observable<boolean> {


    if (this.activeCheckridesValidated) {
      // Ensure we are checking for the same checkride type
      if (this.lastActiveCheckrideTypeId == searchRequest.checkRideTypeId) {
        return of(this.activeCheckrideValidationResult);
      }
    }

    this.lastActiveCheckrideTypeId = searchRequest.checkRideTypeId;
    this.activeCheckridesValidated = true;

    if (this.sectionConfig?.config?.verifyExistingCheckrides == false) {
      this.activeCheckrideValidationResult = true;
      return of(true);
    }

    const variables = this.getVariables();

    if (variables.IgnoreActiveCheckrideCheck) {
      this.activeCheckrideValidationResult = true;
      return of(true);
    }

    const pilexosUser = this.adminManagerSerice.getPilexosUser();

    let email = pilexosUser?.user?.Email;

    let ob = this.applicantRepositoryService.getActiveCheckrides(this.checkRideRequest.CheckRideRequestId, email);

    const schoolUserTypes = [PilexosUserTypeIds.flightSchool, PilexosUserTypeIds.checkInstructor, PilexosUserTypeIds.flightInstructor];
    
    if (schoolUserTypes.includes(pilexosUser.UserTypeId)) {
      ob = this.applicantRepositoryService.getApplicantEmails(this.checkRideRequest.StudentApplicantId, this.checkRideRequest.FlightSchoolApplicantId)
        .pipe(mergeMap(emails => {
          return this.applicantRepositoryService.getActiveCheckrides(this.checkRideRequest.CheckRideRequestId, ...emails);
        }));
    }

    if (this.activeCheckrides) {
      ob = of(this.activeCheckrides);
    }

    return ob.pipe(map(activeCheckrides => {
      this.activeCheckrides = activeCheckrides;

      this.activeCheckrideValidationResult = activeCheckrides.length == 0;

      const matchingActiveCheckrides = activeCheckrides.find(ac => ac.CheckRideGroupId == searchRequest.checkRideGroupId && ac.CheckRideTypeId == searchRequest.checkRideTypeId);
      this.activeCheckrideValidationResult = !matchingActiveCheckrides;

      return this.activeCheckrideValidationResult;
    }));

  }

  convertDate(preferredDateTime: string): string {
    // if (preferredDateTime.indexOf('T') < 0) {
    //   preferredDateTime += 'T00:00:00';
    // }

    const date = new Date(preferredDateTime);

    //return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

    let dateWithTime = date.toJSON();

    const dateOnly = `${dateWithTime.substring(0, 10)}T00:00:00.000Z`

    return dateOnly;
  }

  loadResults(searchRequest: ExaminerLocationSearchRequest, isSearch: boolean, keepMessage: boolean): Observable<PilotExaminerSearchQueryEntityExt[]> {
    this.loading = true;
    this.loadingMessage = "Searching";

    if (!keepMessage) {
      this.message = null;
    }

    this.searchResults = [];

    //this.examinerLocationSelection = null;


    let searchOb = this.examinerRepositoryService.searchExaminerByLocation(searchRequest);

    // if (searchRequest.searchWithinMiles == 101) {
    //   searchOb = this.examinerRepositoryService.searchExaminerByLocationOnClient(searchRequest);
    // }

    return searchOb.pipe(tap(searchResults => {
      this.setupSearchResults(searchResults);
    }));
  }

  private setupSearchResults(searchResults: PilotExaminerSearchQueryEntityExt[]) {
    this.searchResults = searchResults;

    const variableContext = this.getVariables();

    let totalAllowed = 1;
    if (variableContext.Applicants) {
      const applicantIds = variableContext.Applicants.split(',');

      totalAllowed = applicantIds.length;
    }

    this.patchContext({
      ApplicantCount: totalAllowed,
    }
    );

    this.scheduleSelectorService.initSelections(totalAllowed, this.showSearch, searchResults);
  }

  // selectDetail(detail: ExaminerLocationDetail) {
  //   // Deselect all other details
  //   for(const d of this.examinerLocationDetails) {
  //     d.isSelected = false;
  //   }

  //   detail.isSelected = true;

  //   this.examinerLocationSelection.currentSearchResult = detail.searchResult;
  // }

  // confirmDetail() {
  //   this.examinerLocationSelection.confirmed = true;

  //   // Need to do more here
  // }

  // examinerLocationDetailChanged(examinerLocationDetail: ExaminerLocationDetail) {
  //     let selectedCount = 0;

  //     for (const detail of this.examinerLocationDetails) {
  //       selectedCount += detail.scheduleDateTime.length;
  //     }

  //     this.examinerLocationSelection.totalSelected = selectedCount;

  // }

  private getVariables(): ExaminerBookingVariableContext {

    //const variableContext = this.dwMetaDataFormStateService.state.context['variable_contex_-CheckRideRequest'];
    const variableContext: ExaminerBookingVariableContext = this.formApi.getVariableContextValue();

    // if (!variableContext) {
    //   return { searchOtherAirports: false, withinMiles: 0 }
    // };

    variableContext.Search_Other_Airports = variableContext.Search_Other_Airports || false;
   // variableContext.Within_Miles = variableContext.Within_Miles || 50;

    return variableContext;

    // return {
    //   searchOtherAirports: variableContext.value['Search_Other_Airports'],
    //   withinMiles: this.parseInt(variableContext.value['Within_Miles'] || 50),
    //   preferredPilotExaminerId: this.parseInt(variableContext.value['Preferred_Pilot_Examiner_Id']),
    //   showProposedSearch: variableContext.value[this.SHOW_PROPOSED_SEARCH] == true,
    //   showSearch: variableContext.value[this.SHOW_SEARCH] == true,
    //   checkRideNoLongerValid: variableContext.value['Checkride_Date_No_Longer_Valid'] == true,
    //   ignoreActiveCheckrideCheck: variableContext.value['IgnoreActiveCheckrideCheck'] == true,
    // }
  }

  SHOW_SEARCH = 'Show_Search';
  SHOW_PROPOSED_SEARCH = 'Show_Proposed_Search';
  PROPOSAL_PENDING = 'Proposal_Pending';
  Checkride_Date_No_Longer_Valid = 'Checkride_Date_No_Longer_Valid';

  setVariable(variableName: string, value: boolean) {
    const variableContext = this.formApi.getVariableContextValue();

    if (!variableContext) {
      return;
    }

    //console.log(`Setting ${variableName} to ${value}`);

    const variables = {};

    if (variableContext[variableName] == value) {
      return;
    }

    variables[variableName] = value;

    this.formApi.patchVariableContext(variables);

    //variableContext.next(variables);
  }

  patchContext(patchContext: Partial<ExaminerBookingVariableContext>) {
    const variableContext = this.formApi.getVariableContextValue();

    if (!variableContext) {
      return;
    }

    //console.log(`Setting ${variableName} to ${value}`);

    const variables = {};

    let hasChanges = false;
    for (const key of Object.keys(patchContext)) {
      if (variableContext[key] != patchContext[key]) {
        variables[key] = patchContext[key];

        hasChanges = true;
      }
    }

    if (!hasChanges) {
      return;
    }

    this.formApi.patchVariableContext(variables);
  }

  setupVariableChangeWatch() {
    const variableContext = this.formApi.getVariableContext();

    if (!variableContext) {
      return;
    }

    if (this.variableWatchSubscription) {
      this.variableWatchSubscription.unsubscribe();
    }
    this.subscriptions.push(
      this.variableWatchSubscription = variableContext.asObservable()
        .pipe(debounceTime(100))
        .subscribe(variableValues => {
          this.checkforSearchChanges(this.checkRideRequest, this.getVariables());
        }));
  }

  private parseInt(value: string): number {
    if (!value) {
      return null;
    }

    return parseInt(value);
  }

  private cancelScheduleHold(checkRideRequest: CheckRideRequestEntity) {
    const scheduleHold = this.scheduleHoldUtilService.getScheduleHold();

    if (!scheduleHold) {
      return;
    }
    this.scheduleHoldUtilService.cancelScheduleHold(scheduleHold, checkRideRequest)
      .subscribe((result) => {
        // Don't care about the result
      });
  }

  private startScheduleHold(checkRideRequest: CheckRideRequestEntity): Observable<boolean> {
    const variables = this.getVariables();

    const existingHold = this.scheduleHoldUtilService.getScheduleHold();

    return this.scheduleHoldUtilService.startScheduleHold(checkRideRequest).pipe(map(hold => {
      // Check if the hold was successful
      if (hold.ResultAction == ScheduleHoldResultAction.holdStarted) {
        return true;
      }

      // If the hold was not successful, let the user know
      this.message = {
        messageBody: hold.ErrorMessage,
        severity: DwMessageSeverity.error
      }
      return false;
    }));
  }

}
